<template>
  <div
    :class="{
      'tag-label': true,
      'tag-label-warning': label.level === 'WARN',
      'tag-label-error': label.level === 'ERROR',
    }"
    @click="(e) => (label.toast ? showDetail(label.toast, e) : null)"
  >
    <slot name="title">
      <span> {{ label.name || label.title }}</span>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'tag-label',
  props: {
    label: {
      type: Object,
    },
  },
  methods: {
    showDetail(toast, e) {
      e && e.stopPropagation();
      this.$handPlugin.confirm.show({
        titleStyle: { display: 'none' },
        content: toast.replace(/\u001E/g, '\n'),
        textStyle: { whiteSpace: 'pre-line' },
        buttonText: window.$t('expense-4.key21', { cm: '我知道了' }),
        confirmClick: () => {},
      });
    },
  },
};
</script>

<style lang="scss">
.tag-label {
  padding: 4px 8px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
  user-select: none;
  border: 2px solid transparent;
  line-height: px(24);
  background: #dde2e5;
  color: #44474c;

  &-error {
    background: #ffe4db;
    color: #d73453;
  }

  &-warning {
    background: #ffefce;
    color: #db6207;
  }
}
</style>
